.state {
  display: flex;
  align-items: center;
  gap: 0.2rem;
  color: var(--color-primary-puerto-rico);
  animation: fade-out 3s forwards;

  &[data-state='success'] {
    color: var(--color-primary-puerto-rico);
  }

  &[data-state='error'] {
    color: var(--color-secondary-roman);
  }

  @keyframes fade-out {
    0% {
      opacity: 1;
    }
    90% {
      opacity: 1;
    }
    100% {
      display: none;
      opacity: 0;
    }
  }
}
